import axios from 'axios';
import URLS from '../../util/urls.js';

const state = {
  listaPlacas: [],
  labelQuantidade: '',
  placaPesquisa: {
    tipo: undefined,
    pagina: 0
  },
  placaSelecionada: {
    id: 0,
    tipo: '',
    quantidadeDisponivel: 0
  }
};
const mutations = {
  atualizarListaPlacas(state, payload) {
    if(state.placaPesquisa.pagina === 0) {
      state.listaPlacas = payload.lista;
    } else {
      state.listaPlacas.push(...payload.lista);
    }
    state.labelQuantidade = `${payload.quantidade} ${payload.quantidade === 1 ? "Placa encontrada" : "Placas encontradas"}`;
  },
  limparPlacasListadas(state) {
    state.listaPlacas = [];
  },
  limparPlacaPesquisa(state) {
    state.placaPesquisa = {
      tipo: undefined,
      pagina: 0
    }
  },
  atualizarPlacaSelecionada(state, payload) {
    state.placaSelecionada = payload;
  },
  novaPlaca(state) {
    state.placaSelecionada = {
      id: 0,
      tipo: '',
      quantidadeDisponivel: 0
    };
  }
};
const actions = {
  listarPlacas(context, payload) {
    return axios.post(URLS.PLACAS_LISTAR, payload)
      .then((response) => {
        switch(response.data.status) {
          case "SUCESSO":
            context.commit('atualizarListaPlacas', response.data);
            return response.data;
          case "SESSAO_EXPIRADA":
            return context.dispatch('loginStore/relogar', {}, { root: true })
              .then((authResponse) => {
                if(authResponse.status === "SUCESSO") {
                  return context.dispatch('listarPlacas', payload);
                }
              }).catch((error) => {
                throw error;
              });
          default:
            return response.data;
        }
      }).catch((error) => {
        throw error;
      });
  },
  limparPlacasListadas(context) {
    context.commit('limparPlacasListadas');
  },
  limparPlacaPesquisa(context) {
    context.commit('limparPlacaPesquisa');
  },
  recuperarPlaca(context, payload) {
    return axios.post(URLS.PLACAS_RECUPERAR, payload)
      .then((response) => {
        switch(response.data.status) {
          case "SUCESSO":
            context.commit('atualizarPlacaSelecionada', response.data.item);
            return response.data;
          case "SESSAO_EXPIRADA":
            return context.dispatch('loginStore/relogar', {}, { root: true })
              .then((authResponse) => {
                if(authResponse.status === "SUCESSO") {
                  return context.dispatch('recuperarPlaca', payload);
                }
              }).catch((error) => {
                throw error;
              });
          default:
            return response.data;
        }
      }).catch((error) => {
        throw error;
      });
  },
  novaPlaca(context) {
    context.commit('novaPlaca');
  },
  gravarPlaca(context, payload) {
    return axios.post(URLS.PLACAS_GRAVAR, payload)
      .then((response) => {
        switch(response.data.status) {
          case "SUCESSO":
            context.commit('atualizarPlacaSelecionada', response.data.item);
            return response.data;
          case "SESSAO_EXPIRADA":
            return context.dispatch('loginStore/relogar', {}, { root: true })
              .then((authResponse) => {
                if(authResponse.status === "SUCESSO") {
                  return context.dispatch('gravarPlaca', payload);
                }
              }).catch((error) => {
                throw error;
              });
          default:
            return response.data;
        }
      }).catch((error) => {
        throw error;
      });
  },
  removerPlaca(context, payload) {
    return axios.post(URLS.PLACAS_REMOVER, payload)
      .then((response) => {
        switch(response.data.status) {
          case "SUCESSO":
            context.commit('novaPlaca');
            return response.data;
          case "SESSAO_EXPIRADA":
            return context.dispatch('loginStore/relogar', {}, { root: true })
              .then((authResponse) => {
                if(authResponse.status === "SUCESSO") {
                  return context.dispatch('removerPlaca', payload);
                }
              }).catch((error) => {
                throw error;
              });
          default:
            return response.data;
        }
      }).catch((error) => {
        throw error;
      });
  }
};

export default {
  state,
  mutations,
  actions
};